import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=116579e2&scoped=true"
import script from "./TableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=116579e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116579e2",
  null
  
)

export default component.exports